import styled from 'styled-components';
import { body2, colors, spacing } from 'ui/theme';

export const CardBody = styled.div`
  padding: ${spacing.plusHalf};
`;

export const CardFooter = styled.div`
  padding: 0 ${spacing.base} ${spacing.plusHalf};
`;

export const CardRow = styled.div`
  display: flex;

  & + & {
    margin-top: ${spacing.double};
  }
`;

export const CardDetails = styled.div`
  flex-grow: 1;
  ${body2}
`;

export const CardNumber = styled.span`
  display: flex;
  align-items: center;
`;

export const ExpirationDate = styled.span`
  color: ${colors.textSecondary};
`;
